import "react-app-polyfill/stable";
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import './stb_styles.css';
import 'bootstrap/dist/css/bootstrap.css';
import Efilingquestion from './scenes/Form/Efilingquestion';
import FormStateProvider from './scenes/Form/FilingForm';
import EnhancedSearch from './scenes/Search/EnhancedSearch/index';
import Recents from './scenes/Search/Recent/index';
import Confirmation from './scenes/Form/Confirmation';
import Notfound from './scenes/Notfound';
import * as serviceWorker from './serviceWorker';

import { Route, HashRouter as Router, Switch } from 'react-router-dom';

import {
	EFILING_QUESTION_PATH,
	EFILING_PATH,
	INFORMAL_EFILING_PATH,
	ENHANCED_SEARCH_PATH,
	CONFIRMATION_PATH,
	RECENT_DECISIONS_PATH,
	RECENT_FILINGS_PATH,
	DECISIONS_SEARCH_PATH,
	FILINGS_SEARCH_PATH,
	DOCKETS_SEARCH_PATH,
	PAGE_NOT_FOUND_PATH,
	ERECORDATION_PATH,
	RAIL_RECORDATIONS_SEARCH_PATH,
	WATER_RECORDATIONS_SEARCH_PATH,
	RCPA_PATH,
	ENV_COMMENTS_PATH,
	ENV_COMMENTS_SEARCH_PATH
} from './resources/constants/paths';

import {
	DECISIONS_SEARCH_FOR_OPTION,
	FILINGS_SEARCH_FOR_OPTION,
	DOCKETS_SEARCH_FOR_OPTION,
	RECORDATIONS_SEARCH_FOR_OPTION,
	ENVIRONMENTAL_COMMENTS_SEARCH_FOR_OPTION
} from './resources/constants/searches';
import { ErrorBoundary } from './resources/util/ErrorBoundary';
import { 
	OTHER_FILING_FORM_TYPE, 
	FORMAL_FILING_FORM_TYPE, 
	RECORDATION_FORM_TYPE, 
	RCPA_FORM_TYPE,
	ENVIRONMENTAL_COMMENTS_FORM_TYPE
} from './resources/constants/fields';
import { ENV_COMM_TYPES, RECORDATION_CATEGORIES } from "./resources/constants/dropdowns";

const routing = (
	<Router>
		<div>
			<ErrorBoundary>
			<Switch>
				<Route
					path={EFILING_QUESTION_PATH}
					component={Efilingquestion}
				/>
				<Route 
					path={INFORMAL_EFILING_PATH} 
					render={() => (
						<FormStateProvider filingType={OTHER_FILING_FORM_TYPE}/>
					)} 
				/>
				<Route 
					path={EFILING_PATH} 
					render={() => (
						<FormStateProvider filingType={FORMAL_FILING_FORM_TYPE}/>
					)} 
				/>
				<Route 
					path={ERECORDATION_PATH} 
					render={() => (
						<FormStateProvider filingType={RECORDATION_FORM_TYPE}/>
					)} 
				/>
				<Route 
					path={RCPA_PATH} 
					render={() => (
						<FormStateProvider filingType={RCPA_FORM_TYPE}/>
					)} 
				/>
				<Route 
					path={ENV_COMMENTS_PATH} 
					render={() => (
						<FormStateProvider filingType={ENVIRONMENTAL_COMMENTS_FORM_TYPE}/>
					)} 
				/>
				<Route
					exact
					path={ENHANCED_SEARCH_PATH}
					component={EnhancedSearch}
				/>
				<Route
					exact
					path={DECISIONS_SEARCH_PATH}
					render={props => (
						<EnhancedSearch
							{...props}
							lockedTo={DECISIONS_SEARCH_FOR_OPTION}
						/>
					)}
				/>
				<Route
					exact
					path={FILINGS_SEARCH_PATH}
					render={props => (
						<EnhancedSearch
							{...props}
							lockedTo={FILINGS_SEARCH_FOR_OPTION}
						/>
					)}
				/>
				<Route
					exact
					path={RAIL_RECORDATIONS_SEARCH_PATH}
					render={props => (
						<EnhancedSearch
							{...props}
							defaultFields={{recordationCategory:RECORDATION_CATEGORIES[0].value}}
							lockedTo={RECORDATIONS_SEARCH_FOR_OPTION}
						/>
					)}
				/>
				<Route
					exact
					path={WATER_RECORDATIONS_SEARCH_PATH}
					render={props => (
						<EnhancedSearch
							{...props}
							defaultFields={{recordationCategory:RECORDATION_CATEGORIES[1].value}}
							lockedTo={RECORDATIONS_SEARCH_FOR_OPTION}
						/>
					)}
				/>
				<Route
					exact
					path={DOCKETS_SEARCH_PATH}
					render={props => (
						<EnhancedSearch
							{...props}
							lockedTo={DOCKETS_SEARCH_FOR_OPTION}
						/>
					)}
				/>
				<Route
					exact
					path={ENV_COMMENTS_SEARCH_PATH}
					render={props => (
						<EnhancedSearch
							{...props}
							defaultFields={{enviroCommentTypeId:ENV_COMM_TYPES[0].value}}
							lockedTo={ENVIRONMENTAL_COMMENTS_SEARCH_FOR_OPTION}
						/>
					)}
				/>
				<Route
					exact
					path={RECENT_FILINGS_PATH}
					render={() => (
						<Recents searchFor={FILINGS_SEARCH_FOR_OPTION} />
					)}
				/>
				<Route
					exact
					path={RECENT_DECISIONS_PATH}
					render={() => (
						<Recents searchFor={DECISIONS_SEARCH_FOR_OPTION} />
					)}
				/>
				<Route
					exact
					path={`${CONFIRMATION_PATH}/:filingType`}
					component={Confirmation}
				/>
				<Route path={PAGE_NOT_FOUND_PATH} component={Notfound} />
				<Route component={Notfound} />
			</Switch>
			</ErrorBoundary>
		</div>
	</Router>
);

ReactDOM.render(routing, document.getElementById('root'));

serviceWorker.unregister();
